module.exports = __webpack_public_path__ + "static/media/2.28670734.jpg";